export const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
}

export const reduceFontSizePxInHtml = (html, reduceByPx = 2) => {
    return html?.replace(/font-size:\s*(\d+)px;/g, (match, p1) => {
        const originalSize = parseInt(p1, 10);
        if (originalSize < 16) return match;
        const newSize = Math.max(1, Math.min(originalSize - reduceByPx, 28));
        return `font-size: ${newSize}px;`;
    });
  };